
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}},[_c('path',{attrs:{"stroke":"#000","d":"M4.385 20.575h15.23M1.423 11.225h21.154"}}),_c('g',{attrs:{"stroke":"#FFC511"}},[_c('path',{attrs:{"d":"M8.193 13.35v5.1M12.001 13.35v5.1M15.808 13.35v5.1"}})]),_c('path',{attrs:{"stroke":"#000","d":"M4.434 11.18l5.5-6.374M20.075 11.18l-5.5-6.374M4.385 20.575l-1.27-8.925M19.615 20.575l1.27-8.925"}})])])
          )
        }
      }
    